import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskAreaMatrixStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        matrixColumnHeader: {
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            textAlign: "center",
        },
        matrixRowHeader: {
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            textAlign: "right",
            paddingRight: theme.spacing(1),
        },
        axisLabel: {
            fontSize: "0.8rem",
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.primary.dark,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
        },
        verticalAxisLabel: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
        },
        horizontalAxisLabel: {
            textAlign: "center",
            marginTop: theme.spacing(1),
        },
        matrixCell: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "6px",
            cursor: "pointer",
            "& .MuiOutlinedInput-root": {
                backgroundColor: "transparent",
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
            },
            "& .MuiInputBase-input": {
                textAlign: "center",
                fontWeight: theme.typography.fontWeightMedium,
                fontSize: "24px",
                color: "#002677",
                cursor: "pointer",
                transform: "translateY(-4px)",
            },
            // Make it clear which cell is being edited: stroke the cell while its input is focused.
            "&:focus-within": {
                boxShadow: "inset 0 0 0 2px #002677",
            },
        },
        // The badge sits in the cell corner rather than replacing the value, because while editing both
        // numbers matter at once: the level being set and how many assessments it would move.
        editableMatrixCell: {
            position: "relative",
        },
        cellBadge: {
            position: "absolute",
            top: "2px",
            right: "5px",
            fontSize: "0.7rem",
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.secondary,
            pointerEvents: "none",
        },
        matrixCellError: {
            boxShadow: `inset 0 0 0 2px ${theme.palette.error.main}`,
        },
        readOnlyMatrixCell: {
            position: "relative",
            minHeight: "50px",
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: "24px",
            color: "#002677",
            border: "2px solid transparent",
        },
        cellMovement: {
            position: "absolute",
            top: "4px",
            right: "6px",
            display: "flex",
            alignItems: "center",
            gap: "1px",
            fontSize: "0.75rem",
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.secondary,
        },
        selectedMatrixCell: {
            borderColor: "#002677",
        },
        clickableMatrixCell: {
            "&:hover": {
                filter: "brightness(0.9)",
            },
        },
    });
};
